import React from 'react';
import { Button } from 'react-bootstrap';
import ShowRolesList from './RolesList';
import { withRouter } from 'react-router-dom';
import Header from "./header";
import Logger from './Logger';
import noty from './Noty';
import "../../node_modules/noty/lib/noty.css";
import "../../node_modules/noty/lib/themes/bootstrap-v4.css";
import checkForSession from "./SessionChecker";

class Roles extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            roles: [],
            simTitle: '',
            created: '',
            simJoinerName: '',
            isAllSelected: false,
            checkList: [],
            mainHub: props.hub,
            isMultiSimulationAllow: props.isMultiSimulationAllow,
            allRoles: []
        };
        this.routeChange = this.routeChange.bind(this);
        this.userNameChange = this.userNameChange.bind(this);
        this.getAllRoles = this.getAllRoles.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.getUserRolesCount = this.getUserRolesCount.bind(this);
        this.updateRolesCount = this.updateRolesCount.bind(this);
    }

    componentDidMount() {
        this.props.history.location.state == undefined
            ?
            checkForSession(this.props)
            :
            this.initialize();
    }

    initialize() {
        this.getAllRoles();
        this.setStates();
        document.addEventListener("keydown", this.handleKeyPress);
        this.updateRolesCount();
    }

    setStates() {
        let state = this.props.location.state;
        this.setState({
            simTitle: state.title,
            created: state.createdBy,
        })
    }

    componentWillUnmount() {
        this.props.history.goForward();
        document.removeEventListener("keydown", this.handleKeyPress);
    }

    handleKeyPress = (event) => {
        if (event.which === 13) {
            this.routeChange();
        }
    }

    routeChange() {
        const self = this;
        const {simJoinerName, mainHub} = self.state;
        const {simulationID, id, token, createdBy, title, userId, pin, isMultiSimulationAllow} = self.props.location.state;
        let path = '';
        if (simJoinerName.trim() != '' && self.state.roles.length > 0) {
            mainHub.invoke('GetSimulationById',
                simulationID,
                isMultiSimulationAllow
            )
                .then(function (response) {
                    if (response != 'Completed') {
                        var roles = self.state.roles.map(item => item.value).join();
                        path = `tasks`;
                        self.props.history.push({
                            pathname: path,
                            state: {
                                id: id,
                                token,
                                createdBy,
                                title,
                                simulationID,
                                userId,
                                simJoinerName,
                                roles,
                                checkList: self.state.roles,
                                pin,
                                isMultiSimulationAllow,
                                allRoles: self.state.allRoles
                            }
                        });
                    } else {
                        path = "/Feedback/";
                        self.props.history.push({
                            pathname: path,
                            state: {
                                token: token,
                                title: title,
                                createdBy: createdBy,
                            }
                        });
                    }
                })
                .catch(function (error) {
                    noty('error', 'Something went wrong.')
                    Logger('Failed to get simulation by Id.', error.message, error.stack, 'Error');
                });
        }
        else {
            this.nameInput.focus();
        }
    }

    userNameChange(e) {
        this.setState({
            simJoinerName: e.target.value,
        });
    }

    async getAllRoles() {
        const self = this;
        let propsState = this.props.location.state;
        const {isMultiSimulationAllow, mainHub} = self.state;
        await mainHub.invoke('GetAllRoles', propsState.id).then(function (response) {
            let result = JSON.parse(response);
            try {
                self.setState({
                    checkList: result.map(function (e) {
                        return {
                            name: e.Title,
                            value: e.Title,
                            checked: false
                        }
                    }), 
                    allRoles: result.map(function (e) {
                        return {
                            name: e.Title,
                            value: e.Title,
                            checked: false
                        }
                    })
                });
                if(isMultiSimulationAllow)
                    self.getUserRolesCount();
            }
            catch (error) {
                noty('error', 'Something went wrong.')
                Logger('Getting roles failed.', error.message, error.stack, 'Error');
            }
        })
            .catch(function (error) {
                noty('error', 'Something went wrong.')
                Logger('Getting roles failed.', error.message, error.stack, 'Error');
            });
    }

    onCheckBoxChange(checkName, isChecked) {
        let isAllChecked = (checkName === 'all' && isChecked);
        let isAllUnChecked = (checkName === 'all' && !isChecked);
        const checked = isChecked;

        const checkList = this.state.checkList.map((role, index) => {
            if (isAllChecked || role.value === checkName) {
                return Object.assign({}, role, {
                    checked,
                });
            } else if (isAllUnChecked) {
                return Object.assign({}, role, {
                    checked: false,
                });
            }
            return role;
        });
        let isAllSelected = (checkList.findIndex((item) => item.checked === false) === -1) || isAllChecked;
        let roles = checkList.filter((item) => item.checked === true);
        this.setState({
            checkList,
            isAllSelected,
            roles
        });
    }

    getUserRolesCount() {
        let self = this;
        let propsState = this.props.location.state;
        self.state.mainHub.invoke('GetUsersRolesCount', propsState.simulationID)
            .then(function (response) {
                console.log(response);
                let data = [];
                self.state.checkList.map(function (e) {
                    response.map(function (o) {
                        if (e.name.trim() == o.Roles.trim()) {
                            data.push({
                                name: e.name,
                                value: e.value,
                                checked: e.checked,
                                users: o.Users
                            })
                        }
                    })
                })
                self.setState({
                    checkList: data
                })
                console.log(self.state.checkList)
            })
            .catch(function (error) {
                noty('error', 'Something went wrong.')
                Logger('Failed to get user roles count.', error.message, error.stack, 'Error');
            });
    }

    updateRolesCount() {
        let self = this;
        try {
            self.state.mainHub.on('simulationJoined', function (message) {
                self.getUserRolesCount();
            })
        } catch (error) {
            noty('error', 'Something went wrong.')
            Logger('Failed to get user roles count.', error.message, error.stack, 'Error');
        }
    }

    render() {
        let propsState = this.props.location.state;
        if (propsState == undefined) {
            return null;
        }
        return (
            <div>
                <header>
                    <div className="top-header-block">
                        <Header data={propsState} isInput={true} />
                        <div className="UserNameBlock" >
                            <input id="joinerUserName" maxLength={100} type="text" name="" ref={(input) => { this.nameInput = input; }} className="inputUserName" onChange={this.userNameChange} value={this.state.simJoinerName} placeholder="Enter Your Name" />
                        </div>
                    </div>
                </header>
                <main>
                    <div className="mainBodyBlock">
                        <ShowRolesList
                            checkList={this.state.checkList}
                            isAllSelected={this.state.isAllSelected}
                            onCheck={this.onCheckBoxChange.bind(this)}
                        />
                        <div className="main-left-menu-block clearfix">
                            <div className="proceedRolesBlock float-right">
                                <Button className="submitRoles" variant="success" onClick={this.routeChange}>Continue</Button>
                            </div>
                        </div>
                    </div>
                </main>
                <footer>

                </footer>
            </div>
        );
    }
}
export default withRouter(Roles);